
export default {
  name: "uploadFile",
  props: {},
  data() {
    return {
       downloadUrl :"file/download",
       getFileListUrl:"contractfile/getFileList",
       deletfileUrl :"file/delefilebyId"
    };
  },
  methods: {
   async getFileList(objList,keyVal, tagName,docuTypeId) {
      //删除文件
      let url = this.getFileListUrl;
      let params = {
        record: {
          keyval: keyVal,
          tagname: tagName,
          docutypeid:docuTypeId
        }
      };
     await this.axios
        .post(url, params)
        .then(({ data }) => {
          if ("1" === data.code) {
            let fileList = data.data.record.filelist;
            this.$set(this.record,objList,fileList);
          }
        })
        .catch(error => console.log(error));
    },
    async getFileList(objList,keyVal, tagName,docuTypeId,btype) {
      //删除文件
      let url = this.getFileListUrl;
      let params = {
        record: {
          keyval: keyVal,
          tagname: tagName,
          docutypeid:docuTypeId,
          btype:btype
        }
      };
     await this.axios
        .post(url, params)
        .then(({ data }) => {
          if ("1" === data.code) {
            let fileList = data.data.record.filelist;
            this.$set(this.contractForm,objList,fileList);
          }
        })
        .catch(error => console.log(error));
    },
    async getFileList(objList,keyVal, tagName,docuTypeId,btype,checkRequired) {//增加字段必填验证字段
      //删除文件
      let url = this.getFileListUrl;
      let params = {
        record: {
          keyval: keyVal,
          tagname: tagName,
          docutypeid:docuTypeId,
          btype:btype
        }
      };
     await this.axios
        .post(url, params)
        .then(({ data }) => {
          if ("1" === data.code) {
            let fileList = data.data.record.filelist;
            this.$set(this.contractForm,objList,fileList);
            if(fileList.length>0){
              this.$set(this.contractForm,checkRequired,fileList.length);
            }
          }
        })
        .catch(error => console.log(error));
    },
    loadFile(fileId, fileName, fileUrl,fileSize) {//下载
      //设置文件信息
      let params = {
        record: {
          fileid: fileId,
          filename: fileName,
          url: fileUrl
        }
      };
      this.axios
        .posttype(this.downloadUrl, params, "arraybuffer")
        .then(res => {
          let blob = new Blob([res.data]);
          let url = window.URL.createObjectURL(blob); //表示一个指定的file对象或Blob对象
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = fileName; //命名下载名称
          a.click(); //点击触发下载
          window.URL.revokeObjectURL(url); //下载完成进行释放
          document.body.removeChild(a);
        })
        .catch(error => console.log(error));
    },
    loadFile(fileInfo,rowIndex) {//带进度条下载
      //设置文件信息
      let params = {
        record: {
          fileid: fileInfo.fileid,
          filename: fileInfo.filename,
          url: fileInfo.upfile
        }
      };
      let fileSize=fileInfo.filesize;
      this.$set(fileInfo, "ifDownProgress", true);
      this.$set(fileInfo, "downpercentage", 0);
      let config = {
        onDownloadProgress: ProgressEvent => {
           let progressPercent = (ProgressEvent.loaded / fileSize * 100).toFixed(2);
           if(progressPercent>=100){
              progressPercent=99;
            }
            this.$set(fileInfo, "downpercentage", parseInt(progressPercent));
        }
      }
      this.axios
        .posttype2(this.downloadUrl, params, "arraybuffer",config)
        .then(res => {
          let blob = new Blob([res.data]);
          let url = window.URL.createObjectURL(blob); //表示一个指定的file对象或Blob对象
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = fileInfo.filename; //命名下载名称
          a.click(); //点击触发下载
          window.URL.revokeObjectURL(url); //下载完成进行释放
          document.body.removeChild(a);
          this.$set(fileInfo, "downpercentage",100);
          let _this=this;
          setTimeout(function()  {
            _this.$set(fileInfo, "ifDownProgress",false);
          }, 2000);
        })
        .catch(error => console.log(error));
    },
    delFile(fileList, fileId, index) {
      //删除文件
      let url = this.deletfileUrl;
      let params = {
        delfileids: [fileId]
      };
      this.axios
        .post(url, params)
        .then(({ data }) => {
          if ("1" === data.code) {
            this.tipSuccess(this.$t("common.delsuccess"));
            fileList.splice(index, 1);
          }
        })
        .catch(error => console.log(error));
    },
    delFile2(fileList, fileId, index) {
      //删除文件
      let url = this.deletfileUrl;
      let params = {
        delfileids: [fileId]
      };
      this.axios
        .post(url, params)
        .then(({ data }) => {
          if ("1" === data.code) {
            this.tipSuccess(this.$t("common.delsuccess"));
            fileList.splice(index, 1);
            if (this.delBackFunc) {
              this.delBackFunc();
            }
          }
        })
        .catch(error => console.log(error));
    }
  }
};



// WEBPACK FOOTER //
// ./src/pcpage/contract/file/uploadFile.vue